/* istanbul ignore file: Directive */
'use strict';

/**
 * Some form elements are just used to offer more options to the form
 * (i.e. a checkbox deploying additional fields, without changing them)
 * And we don't want them to change the form pristine state.
 * That's what this directive is for.
 * Source:
 *  http://stackoverflow.com/questions/28721959/angular-1-2-is-it-possible-to-exclude-an-input-on-form-dirty-checking
 */

customerZone.directive('ignoreDirty', [function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
            ctrl.$pristine = false;
        }
    };
}]);
